import type { JSX } from 'react'

// Icones da Central da Carteira, em SVG inline como o rodape (Layout.tsx): sem
// biblioteca nova. `currentColor` -- a cor vem do card.
export type NomeIcone = 'pessoas' | 'check' | 'pessoaX' | 'alerta' | 'queda' | 'pino' | 'calendario'

const DESENHO: Record<NomeIcone, JSX.Element> = {
  pessoas: (
    <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 9a7 7 0 0 1 14 0v1H2v-1Zm14.5-9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.5 2.1A6.5 6.5 0 0 1 22 19v2h-4v-1a8.9 8.9 0 0 0-2.3-6 6.4 6.4 0 0 1 2.3-.9Z" fill="currentColor" />
  ),
  check: (
    <>
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path d="m7.5 12.5 3 3 6-6.5" fill="none" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  pessoaX: (
    <>
      <path d="M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 10a7 7 0 0 1 12-4.9V21H3Z" fill="currentColor" />
      <path d="m17 15 5 5m0-5-5 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </>
  ),
  alerta: (
    <>
      <path d="M10.3 3.6a2 2 0 0 1 3.4 0l8.4 14.6A2 2 0 0 1 20.4 21H3.6a2 2 0 0 1-1.7-2.8l8.4-14.6Z" fill="currentColor" />
      <path d="M12 9v5" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="12" cy="17.3" r="1.2" fill="white" />
    </>
  ),
  queda: (
    <path d="M3 6l7 7 4-4 7 7m0 0v-5m0 5h-5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  ),
  pino: (
    <>
      <path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12Z" fill="currentColor" />
      <circle cx="12" cy="10" r="2.6" fill="white" />
    </>
  ),
  calendario: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M3 10h18M8 3v4m8-4v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M7.5 14h2m2.5 0h2m2.5 0h2M7.5 17.5h2m2.5 0h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
}

export function Icone({ nome }: { nome: NomeIcone }) {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0" aria-hidden>
      {DESENHO[nome]}
    </svg>
  )
}
